import * as React from "react";
import { Button, Group } from "react-ui";

import { InternalIcon } from "../../Icons/Icon";

import { ComboBoxProps } from "./ComboBox";

const handleRestore = (props: ComboBoxProps) => props.onChange(props.autoValue ?? "");

export const ComboboxWithAuto = (props: { comboboxProps: ComboBoxProps; children: React.ReactNode }): JSX.Element => {
    const { children } = props;
    const { auto, autoFlag, width, disabled } = props.comboboxProps;
    const button = (
        <Button narrow onClick={() => handleRestore(props.comboboxProps)} disabled={disabled}>
            <InternalIcon name={"ArrowDUturnLeftDownIcon"} />
        </Button>
    );

    return (
        <Group width={width}>
            {auto && !autoFlag && button}
            {children}
        </Group>
    );
};
